const asElement = (value) => {
    const candidate = value;
    return candidate != null && typeof candidate.closest === "function" ? candidate : null;
};
const closestOrNull = (element, selector) => {
    try {
        return element.closest(selector);
    }
    catch (error) {
        return null;
    }
};
const findTarget = (event, targets) => {
    const clicked = asElement(event.target);
    if (clicked == null) {
        return null;
    }
    const match = targets
        .map((target) => ({ name: target.name, element: closestOrNull(clicked, target.selector) }))
        .find((candidate) => candidate.element != null);
    return match != null ? { element: match.element, name: match.name } : null;
};
const roundOrNull = (value) => typeof value === "number" && Number.isFinite(value) ? Math.round(value) : null;
const round = (value) => { var _a; return (_a = roundOrNull(value)) !== null && _a !== void 0 ? _a : 0; };
const readScroll = (doc) => {
    var _a, _b;
    const scroller = (_b = (_a = doc === null || doc === void 0 ? void 0 : doc.scrollingElement) !== null && _a !== void 0 ? _a : doc === null || doc === void 0 ? void 0 : doc.documentElement) !== null && _b !== void 0 ? _b : null;
    const view = doc === null || doc === void 0 ? void 0 : doc.defaultView;
    return {
        scrollLeft: round(scroller != null ? scroller.scrollLeft : view === null || view === void 0 ? void 0 : view.pageXOffset),
        scrollTop: round(scroller != null ? scroller.scrollTop : view === null || view === void 0 ? void 0 : view.pageYOffset),
    };
};
export const readClickGeometry = (event, targets) => {
    var _a, _b, _c, _d, _e;
    if (targets.length === 0) {
        return null;
    }
    const match = findTarget(event, targets);
    if (match == null) {
        return null;
    }
    const mouseEvent = event;
    const doc = match.element.ownerDocument;
    const view = (_a = doc === null || doc === void 0 ? void 0 : doc.defaultView) !== null && _a !== void 0 ? _a : null;
    const rect = match.element.getBoundingClientRect();
    const scroll = readScroll(doc);
    return {
        target: match.name,
        targetTag: ((_c = (_b = asElement(event.target)) === null || _b === void 0 ? void 0 : _b.tagName) !== null && _c !== void 0 ? _c : "").toLowerCase(),
        clickX: roundOrNull(mouseEvent.clientX),
        clickY: roundOrNull(mouseEvent.clientY),
        viewportWidth: round(view === null || view === void 0 ? void 0 : view.innerWidth),
        viewportHeight: round(view === null || view === void 0 ? void 0 : view.innerHeight),
        screenWidth: round((_d = view === null || view === void 0 ? void 0 : view.screen) === null || _d === void 0 ? void 0 : _d.width),
        screenHeight: round((_e = view === null || view === void 0 ? void 0 : view.screen) === null || _e === void 0 ? void 0 : _e.height),
        elementX: round(rect.left),
        elementY: round(rect.top),
        elementWidth: round(rect.width),
        elementHeight: round(rect.height),
        scrollLeft: scroll.scrollLeft,
        scrollTop: scroll.scrollTop,
    };
};
export default readClickGeometry;
